export const SET_JOBS = "SET_JOBS";
export const REMOVE_JOB = "REMOVE_JOB";